import { BaseUrl } from "..";
import topTost from "./topTost";

const propsalRelatedOptions = [
  { value: "lead", label: "Lead", icon: "feather-at-sign" },
  { value: "coustomer", label: "Coustomer", icon: "feather-users" },
];
const propsalDiscountOptions = [
  { value: "no-discount", label: "No Discount" },
  { value: "before-tax", label: "Before Tax" },
  { value: "after-tax", label: "After Tax" },
];
const propsalVisibilityOptions = [
  { value: "public", label: "Public", icon: "feather-globe" },
  { value: "private", label: "Private", icon: "feather-lock" },
  { value: "personal", label: "Personal", icon: "feather-user" },
  { value: "customs", label: "Customs", icon: "feather-settings" },
];
const propasalLeadOptions = [
  {
    value: "web",
    label: "Alexandra Della - Website design and development",
    img: "/images/avatar/1.png",
  },
  {
    value: "ui",
    label: "Curtis Green - User experience (UX) and user interface (UI) design",
    img: "/images/avatar/1.png",
  },
  {
    value: "mobile",
    label: "Marianne Audrey - Responsive and mobile design",
    img: "/images/avatar/1.png",
  },
  {
    value: "ecommerce",
    label: "Holland Scott - E-commerce website design and development",
    img: "/images/avatar/1.png",
  },
  {
    value: "ecommerce",
    label: "Olive Delarosa - Custom graphics and icon design",
    img: "/images/avatar/1.png",
  },
];
const propsalStatusOptions = [
  { value: "sent", label: "Sent", color: "#41b2c4" },
  { value: "draft", label: "Draft", color: "#64748b" },
  { value: "open", label: "Open", color: "#3454d1" },
  { value: "revised", label: "Revised", color: "#ffa21d" },
  { value: "declined", label: "Declined", color: "#ea4d4d" },
  { value: "accepted", label: "Accepted", color: "#17c666" },
];

const customerViewOptions = [
  { value: "sms", label: "SMS", icon: "feather-smart-phone" },
  { value: "push", label: "Push", icon: "feather-bell" },
  { value: "email", label: "Email", icon: "feather-mail" },
  { value: "repeat", label: "Repeat", icon: "feather-repeat" },
  { value: "deactivate", label: "Deactivate", icon: "feather-bell-off" },
  { value: "sms-push", label: "SMS + Push", icon: "feather-smart-phone" },
  { value: "email-push", label: "Email + Push", icon: "feather-mail" },
  { value: "sms-email", label: "SMS + Email", icon: "feather-smart-phone" },
  {
    value: "sms-push-email",
    label: "SMS + Push + Email",
    icon: "feather-smart-phone",
  },
];

const customerListTagsOptions = [
  { value: "vip", label: "VIP", color: "#17c666" },
  { value: "bugs", label: "Bugs", color: "#3dc7be" },
  { value: "team", label: "Team", color: "#3454d1" },
  { value: "updates", label: "Updates", color: "#17c666" },
  { value: "personal", label: "Personal", color: "#ffa21d" },
  { value: "promotions", label: "Promotions", color: "#ea4d4d" },
  { value: "high-budget", label: "High Budget", color: "#41b2c4" },
  { value: "customs", label: "Customs", color: "#6610f2" },
  { value: "low-budget", label: "Low Budget", color: "#ea4d4d" },
  { value: "wholesale", label: "Wholesale", color: "#3454d1" },
  { value: "primary", label: "Primary", color: "#41b2c4" },
];
const customerListStatusOptions = [
  { value: "active", label: "Active", color: "#17c666" },
  { value: "inactive", label: "Inactive", color: "#ffa21d" },
  { value: "declined", label: "Declined", color: "#ea4d4d" },
];
const customerCreatePrivacyOptions = [
  { value: "onlyme", label: "Only Me", icon: "feather-lock" },
  { value: "everyone", label: "Everyone", icon: "feather-globe" },
  { value: "anonymous", label: "Anonymous", icon: "feather-users" },
  { value: "ifollow", label: "People I Follow", icon: "feather-user-check" },
  { value: "followme", label: "People Follow Me", icon: "feather-eye" },
  {
    value: "customselectever",
    label: "Custom Select Ever",
    icon: "feather-settings",
  },
];
const leadsGroupsOptions = [
  { value: "group-a", label: "Group-A", color: "#17c666" },
  { value: "group-b", label: "Group-B", color: "#283c50" },
  { value: "group-c", label: "Group-C", color: "#3454d1" },
  { value: "group-d", label: "Group-D", color: "#41b2c4" },
  { value: "group-e", label: "Group-E", color: "#17c666" },
  { value: "group-f", label: "Group-F", color: "#ffa21d" },
  { value: "group-g", label: "Group-G", color: "#ea4d4d" },
  { value: "group-h", label: "Group-H", color: "#6610f2" },
  { value: "group-i", label: "Group-I", color: "#3454d1" },
  { value: "group-j", label: "Group-J", color: "#ea4d4d" },
  { value: "group-k", label: "Group-K", color: "#41b2c4" },
];

const taskStatusOptions = [
  { value: "inprogress", label: "Inprogress", color: "#3454d1" },
  { value: "pending", label: "Pending", color: "#64748b" },
  { value: "completed", label: "Completed", color: "#17c666" },
  { value: "rejected", label: "Rejected", color: "#ea4d4d" },
  { value: "upcoming", label: "Upcoming", color: "#ffa21d" },
  { value: "auto", label: "Auto", color: "#283c50" },
];

const taskPriorityOptions = [
  { value: "low", label: "Low", color: "#3454d1" },
  { value: "normal", label: "Normal", color: "#64748b" },
  { value: "medium", label: "Medium", color: "#17c666" },
  { value: "high", label: "High", color: "#ffa21d" },
  { value: "urgent", label: "Urgent", color: "#ea4d4d" },
];

const taskLabelsOptions = [
  { value: "team", label: "Team", color: "#3454d1" },
  { value: "primary", label: "Primary", color: "#41b2c4" },
  { value: "updates", label: "Updates", color: "#17c666" },
  { value: "personal", label: "Personal", color: "#ffa21d" },
  { value: "promotions", label: "Promotions", color: "#ea4d4d" },
  { value: "customs", label: "Customs", color: "#6610f2" },
];
const taskTypeOptions = [
  { value: "new", label: "New", color: "#3454d1" },
  { value: "pending", label: "Pending", color: "#41b2c4" },
  { value: "progress", label: "Progress", color: "#17c666" },
  { value: "completed", label: "Completed", color: "#ffa21d" },
  { value: "everythings", label: "Everythings", color: "#ea4d4d" },
];

const taskAssigneeOptions = [
  {
    img: "/images/avatar/2.png",
    label: "arcie.tones@gmail.com",
    value: "arcie.tones@gmail.com",
  },

  {
    img: "/images/avatar/3.png",
    label: "jon.tones@gmail.com",
    value: "jon.tones@gmail.com",
  },
  {
    img: "/images/avatar/4.png",
    label: "lanie.nveyn@gmail.com",
    value: "lanie.nveyn@gmail.com",
  },
  {
    img: "/images/avatar/5.png",
    label: "nneth.une@gmail.com",
    value: "nneth.une@gmail.com",
  },
  {
    img: "/images/avatar/6.png",
    label: "erna.serpa@outlook.com",
    value: "erna.serpa@outlook.com",
  },
  {
    img: "/images/avatar/7.png",
    label: "mar.audrey@gmail.com",
    value: "mar.audrey@gmail.com",
  },
  {
    img: "/images/avatar/8.png",
    label: "nancy.elliot@outlook.com",
    value: "nancy.elliot@outlook.com",
  },
];

const leadsStatusOptions = [
  { value: "new", label: "New", color: "#3454d1" },
  { value: "contacted", label: "Contacted", color: "#41b2c4" },
  { value: "working", label: "Working", color: "#ffa21d" },
  { value: "qualified", label: "Qualified", color: "#17c666" },
  { value: "declined", label: "Declined", color: "#ea4d4d" },
  { value: "customer", label: "Customer", color: "#6610f2" },
];

const leadsSourceOptions = [
  { value: "facebook", label: "Facebook", icon: "feather-facebook" },
  { value: "twitter", label: "Twitter", icon: "feather-twitter" },
  { value: "instagram", label: "Instagram", icon: "feather-instagram" },
  { value: "linkedin", label: "Linkedin", icon: "feather-linkedin" },
  { value: "search-engine", label: "Search Engine", icon: "feather-search" },
  { value: "others", label: "Others", icon: "feather-compass" },
];

const projectStatusOptions = [
  { value: "in-projress", label: "In Projress", color: "#3454d1" },
  { value: "not-started", label: "Not Started", color: "#ffa21d" },
  { value: "on-hold", label: "On Hold", color: "#17c666" },
  { value: "declined", label: "Declined", color: "#ea4d4d" },
  { value: "finished", label: "Finished", color: "#41b2c4" },
  { value: "active", label: "Active", color: "#17c666" },
];
const projectBillingOptions = [
  { value: "fixed-rate", label: "Fixed Rate", color: "#3454d1" },
  { value: "tasks-hours", label: "Tasks Hours", color: "#ffa21d" },
  { value: "project-hours", label: "Project Hours", color: "#17c666" },
];
const projectNotificationsOptions = [
  {
    value: "specific-contacts",
    label: "Specific Contacts",
    icon: "feather-user",
  },
  {
    value: "dont-send",
    label: "Don't send notification",
    icon: "feather-bell-off",
  },
  {
    value: "all",
    label: "All contact with notification",
    icon: "feather-bell",
  },
];
const projectRoalOptions = [
  { value: "admin", label: "Admin", color: "#3454d1" },
  { value: "guest", label: "Guest", color: "#41b2c4" },
  { value: "editor", label: "Editor", color: "#ea4d4d" },
  { value: "owner", label: "Owner", color: "#ffa21d" },
  { value: "customer", label: "Customer", color: "#17c666" },
];
export {
  propsalRelatedOptions,
  propsalDiscountOptions,
  propsalVisibilityOptions,
  propasalLeadOptions,
  propsalStatusOptions,
  customerViewOptions,
  customerListTagsOptions,
  customerListStatusOptions,
  customerCreatePrivacyOptions,
  leadsGroupsOptions,
  taskStatusOptions,
  taskPriorityOptions,
  taskLabelsOptions,
  taskAssigneeOptions,
  leadsStatusOptions,
  leadsSourceOptions,
  projectStatusOptions,
  projectBillingOptions,
  projectNotificationsOptions,
  projectRoalOptions,
  taskTypeOptions,
};

export const handleKeyPress = (e) => {
  const charCode = e.which || e.keyCode;
  if (charCode < 48 || charCode > 57) {
    e.preventDefault();
  }
};

export const getActiveData = (data) =>
  data && data.filter((item) => item.active === true);

// export const getValueLabel = (data, labelKey, valueKey = 'id') => {
//   if (data && Array.isArray(data)) {
//     return data
//       .map((val) => {
//         const rawLabel = val[labelKey] || '';
//         const capitalizedLabel =
//           rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1).toLowerCase();

//         return {
//           value: val[valueKey],
//           label: capitalizedLabel,
//         };
//       })
//       .sort((a, b) => {
//         const labelA = a.label.toLowerCase();
//         const labelB = b.label.toLowerCase();
//         return labelA.localeCompare(labelB);
//       });
//   } else {
//     console.error("Invalid data provided");
//     return [];
//   }
// };
export const getValueLabel = (data, labelKey, valueKey = "id") => {
  if (data && Array.isArray(data)) {
    return data
      .map((val) => {
        const rawLabel = val[labelKey] || "";
        const capitalizedLabel =
          rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1).toLowerCase();

        return {
          value: val[valueKey],
          label: capitalizedLabel,
        };
      })
      .sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });
  } else {
    console.error("Invalid data provided");
    return [];
  }
};

export const fetchData = async (endpoint, params = {}, method = "POST") => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await fetch(`${BaseUrl}${endpoint}`, {
      method: method,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: method === "POST" ? JSON.stringify(params) : null,
    });
    const data = await response.json();

    if (data.result?.code === 200) {
      return data.result;
    } else {
      topTost({
        title: data.result?.message,
        icon: "error",
      });
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

export const fetchData1 = async (endpoint, params = {}, method = "POST") => {
  const token = localStorage.getItem("access_token");

  try {
    const response = await fetch(`${BaseUrl}${endpoint}`, {
      method: method,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: method === "POST" ? JSON.stringify(params) : null,
    });

    const data = await response.json();

    if (data.status === true) {
      return data;
    } else {
      topTost({
        title: data.result?.message,
        icon: "error",
      });
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

export const fetchFormData = async (endpoint, formData, method = "POST") => {
  const token = localStorage.getItem("access_token");
  try {
    const response = await fetch(`${BaseUrl}${endpoint}`, {
      method: method,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await response.json();
    if (
      data.result?.code === 200 ||
      data.result?.code === 201 ||
      data.status == true
    ) {
      return data.result;
    } else if (data.result?.code === 500) {
      topTost({
        title: data.result.message,
        icon: "error",
      });
    } else if (data.result?.code === 409) {
      topTost({
        title: data.result.message,
        icon: "error",
      });
    } else if (data.result?.code === 422) {
      console.log(data.result.message);
      topTost({
        title: data.result.message,
        icon: "error",
      });
    } else {
      topTost({
        title: data.result?.message,
        icon: "error",
      });

      console.error("FormData submission failed:", data);
      return null;
    }
  } catch (error) {
    console.error("Error submitting form data:", error);
    return null;
  }
};
export const loanSegmentOptions = [
  { label: "Secured", value: 1 },
  { label: "Unsecured", value: 2 },
  { label: "Insurance", value: 3 },
];
export const leadPriorityData = [
  { label: "High", value: "1", color: "#E53935" },
  { label: "Medium", value: "2", color: "#FB8C00" },
  { label: "Low", value: "3", color: "#43A047" },
];

export const employmentTypeOptions = [
  { label: "Salaried", value: "salaried" },
  { label: "Self-Employed", value: "self_employed" },
  { label: "Unemployed", value: "unemployed" },
  { label: "Student", value: "student" },
  { label: "Retired", value: "retired" },
];

export const YearformatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-"; // Checks for invalid date

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

// For today's Date
export const getTodayDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0"); // Pad single digit days with leading zero
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = today.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getInitialColumnVisibility = (columns) => {
  return Object.fromEntries(
    columns
      .filter((col) => col.accessorKey)
      .map((col) => [
        col.accessorKey,
        col.accessorKey === "actions"
          ? true
          : col.defaultIsVisible !== undefined
          ? col.defaultIsVisible
          : false,
      ])
  );
};
export const formatDateTimeLocal = (date) => {
  if (!date) return "";
  const pad = (n) => n.toString().padStart(2, "0");
  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const min = pad(date.getMinutes());
  return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
};

export const formatDateOnly = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d)) return ""; // invalid date handling
  const pad = (n) => n.toString().padStart(2, "0");
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  return `${dd}-${mm}-${yyyy}`; // <- updated format here
};
// utils/options.js
export const formatDateOnly1 = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date)) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const getTodayDateISO = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`; // Format: YYYY-MM-DD
};

export const getNowDateTimeLocal = () => {
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, "0");
  const yyyy = now.getFullYear();
  const mm = pad(now.getMonth() + 1);
  const dd = pad(now.getDate());
  const hh = pad(now.getHours());
  const min = pad(now.getMinutes());
  return `${yyyy}-${mm}-${dd}T${hh}:${min}`; // Format for input[type="datetime-local"]
};

export const formatTimeOnly = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
